import { Component } from '@angular/core';

@Component({
  selector: 'app-user-account-not-found',
  templateUrl: './user-account-not-found.component.html',
})
export class UserAccountNotFoundComponent {}
